<div class="lightBox cropimagelightbox block">
  <ng-container *ngIf="!cropperImageUrl || !cropperImageUrl.data || cropperImageUrl.data === null || !reloadEl">
    <div class="unlockStory">
      <div class="wid100">
        <h3 class=" pad30">Loading Image</h3>
        <div class="imagepreloader">
          <div class="a" style="--n: 5;">
            <div class="dot dot1" style="--i: 0;"></div>
            <div class="dot dot2" style="--i: 1;"></div>
            <div class="dot dot3" style="--i: 2;"></div>
            <div class="dot dot4" style="--i: 3;"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="unlockStory" *ngIf="reloadEl && cropperImageUrl && (cropperImageUrl.data || cropperImageUrl.data !== null)">
    <div class="wid100">
      <div class="fr  right padlr30 ptb15">
        <button type="button" name="cancel" (click)="cancelCropping()" class="cancel gray ml10">Cancel</button>
        <button type="button" name="unlock" id="buttonCropingDone" [disabled]="(angularCropper169 && angularCropper169.isLoading)
      || (angularCropper11 && angularCropper11.isLoading)
      || (angularCropper23 && angularCropper23.isLoading)
      || (angularCropper916 && angularCropper916.isLoading)" (click)="startCropping()" [class]="((angularCropper169 && angularCropper169.isLoading)
        || (angularCropper11 && angularCropper11.isLoading)
        || (angularCropper23 && angularCropper23.isLoading)) 
        || (angularCropper916 && angularCropper916.isLoading) ? 'add gray ml10' : 'add blue ml10'">Done</button>
      </div>
      <h3 class=" pad30 pad20" *ngIf="!isHowToStepsImage && addVideoThumbnail==false && !ogImage">Crop Lead Media</h3>
      <h3 class=" pad30 pad20" *ngIf="isHowToStepsImage">Crop Step Image</h3>
      <h3 class=" pad30 pad20" *ngIf="addVideoThumbnail">Crop Video Thumbnail</h3>
      <h3 class=" pad30 pad20" *ngIf="ogImage">Crop OG Image</h3>
      <div class="ratioContainer" *ngIf="ogImage">
        <label class="radioNew">Ratios</label>
                  <div class="dataField" >
                      <label class="radioBlock" *ngFor="let item of ogRatios">
                          <input type="radio" name="options"
                          [checked]="item == cropperToShow[0]"
                          (click)="changeOGRatio(item)" />
                          <span class="radiomark1"></span>
                          {{item | titlecase}}
                      </label>
                  </div>
      </div>
      <div class="cropimageblock pad30">
        <div class="cropAspectRatio">
          <div class="crop169" *ngIf="cropperToShow.indexOf('16:9') > -1">
            <angular-cropper #angularCropper169 id="169" [cropperOptions]="cropperConfig169"
              [imageUrl]="cropperImageUrl.data"></angular-cropper>
            <div class="fl imageratio">16:9 Ratio</div>
            <div class="fr ratioslide">
              <i class="icon-image fl"></i>
              <input type="range" min="1" max="10" #ref1 value="3" class="sliderrange"
                (input)="zoomSlider(ref1.value, '16:9')">
              <i class="icon-image fr"></i>
            </div>
          </div>

          <div class="crop169" *ngIf="cropperToShow.indexOf('9:16') > -1">
            <angular-cropper #angularCropper916 id="916" [cropperOptions]="cropperConfig916"
              [imageUrl]="cropperImageUrl.data"></angular-cropper>
            <div class="fl imageratio">9:16 Ratio</div>
            <div class="fr ratioslide">
              <i class="icon-image fl"></i>
              <input type="range" min="1" max="10" #ref1 value="3" class="sliderrange"
                (input)="zoomSlider(ref1.value, '9:16')">
              <i class="icon-image fr"></i>
            </div>
          </div>
          
          <div class="crop11 relative" *ngIf="cropperToShow.indexOf('1:1') > -1">
            <angular-cropper #angularCropper11 id="11" [cropperOptions]="cropperConfig11"
              [imageUrl]="getImageSource()"></angular-cropper>
              <button *ngIf="isSecondImagePresent()" class="reset" (click)="setFirstImageData()">Reset Image</button>
            <div *ngIf="isMultipleLeadImageAllowed && !isHowToStepsImage" class="fl useDifferentImage"  [ngClass]="{'active' : leadMediaImageToggle}" 
            (click)="leadMediaImageToggle = !leadMediaImageToggle;">Use different Image</div>
            <div [class]="'imageAction' +  (leadMediaImageToggle ? ' block' : '') ">
              <div class="blockContain gifImageUpload" *ngIf="leadMediaImageGif">
                <div class="uploadimage">
                  <i class="icon-upload"></i>
                  <div class="upload-btn-wrapper">
                    <span class="btn">Upload new File</span>
                    <input type="file" name="myfile" accept="image/*" (change)="uploadAnotherImage($event, 'upload')">
                  </div>
                </div>
              </div>
              <div class="blockContain" *ngIf="!leadMediaImageGif">
                <div class="uploadimage">
                  <i class="icon-upload"></i>
                  <div class="upload-btn-wrapper">
                    <span class="btn">Upload new File</span>
                    <input type="file" name="myfile" accept="image/*" (change)="uploadAnotherImage($event, 'upload')">
                  </div>
                </div>
                <div class="pickimage">
                  <i class="icon-image-library"></i>
                  <span (click)="showGallery()" class="pickimageBtn">Pick from Image Library</span>
                </div>
              </div>
            </div>

            <div class="fl imageratio">1:1 Ratio</div>
            <div class="fr ratioslide">
              <i class="icon-image fl"></i>
              <input type="range" min="1" max="10" #ref2 value="3" class="sliderrange"
                (input)="zoomSlider(ref2.value, '1:1')">
              <i class="icon-image fr"></i>
            </div>
          </div>
          <div class="crop23" *ngIf="cropperToShow.indexOf('2:3') > -1">
            <angular-cropper #angularCropper23 id="23" [cropperOptions]="cropperConfig23"
              [imageUrl]="cropperImageUrl.data"></angular-cropper>
            <div class="fl imageratio">2:3 Ratio</div>
            <div class="fr ratioslide">
              <i class="icon-image fl"></i>
              <input type="range" min="1" max="10" #ref3 value="3" class="sliderrange"
                (input)="zoomSlider(ref3.value, '2:3')">
              <i class="icon-image fr"></i>
            </div>
          </div>

          <div class="crop23" *ngIf="cropperToShow.indexOf('2:1') > -1">
            <angular-cropper #angularCropper21 id="21" [cropperOptions]="cropperConfig21"
              [imageUrl]="cropperImageUrl.data"></angular-cropper>
            <div class="fl imageratio">2:1 Ratio</div>
            <div class="fr ratioslide">
              <i class="icon-image fl"></i>
              <input type="range" min="1" max="10" #ref5 value="3" class="sliderrange"
                (input)="zoomSlider(ref5.value, '2:1')">
              <i class="icon-image fr"></i>
            </div>
          </div>

          <div class="crop45" *ngIf="cropperToShow.indexOf('4:5') > -1">
            <angular-cropper #angularCropper45 id="45" [cropperOptions]="cropperConfig45"
              [imageUrl]="cropperImageUrl.data"></angular-cropper>
            <div class="fl imageratio">4:5 Ratio</div>
            <div class="fr ratioslide">
              <i class="icon-image fl"></i>
              <input type="range" min="1" max="10" #ref4 value="3" class="sliderrange"
                (input)="zoomSlider(ref4.value, '4:5')">
              <i class="icon-image fr"></i>
            </div>
          </div>
          <div class="crop43" *ngIf="cropperToShow.indexOf('4:3') > -1">
            <angular-cropper #angularCropper43 id="43" [cropperOptions]="cropperConfig43"
              [imageUrl]="cropperImageUrl.data"></angular-cropper>
            <div class="fl imageratio">4:3 Ratio</div>
            <div class="fr ratioslide">
              <i class="icon-image fl"></i>
              <input type="range" min="1" max="10" #ref5 value="3" class="sliderrange"
                (input)="zoomSlider(ref5.value, '4:3')">
              <i class="icon-image fr"></i>
            </div>
          </div>
<!-- 
          <label class="checkblock showLeadToggle" tabindex="0" *ngIf="(isImageLead && showLeadToggle) || addVideoThumbnail">Display on website
            <input type="checkbox" (click)="toggleSwitch('leadToggle')" [checked]="verticalImageFlag">
            <span class="checkmark"></span>
          </label> -->
        </div>
      </div>
    </div>
    <ng-container *ngIf="editLeadImageName">
      <div class="editImageName">
        <label>Edit Image Name</label>
        
      <input type="text" id="editImageName" class="editImageCss" name="editImageName" [(ngModel)]="imageFileName" (keyup)="checkSpecialChars()">
      <span>{{imageFileName.length}}/50 chars</span>
    </div>
    </ng-container>
    
  </div>
</div>


<div class="lightBox block" *ngIf="isLightbox">
  <div class="headerLight">
    <div class="close fl spImg" (click)="disableshowGallery()"></div>
  </div>
  <div class="photo-listing" [photogalleryId]="false" (emitIdfn)="uploadAnotherImage($event, 'pick')"></div>
</div>